import { render, staticRenderFns } from "./CompanySpace.vue?vue&type=template&id=0fd6af0b&scoped=true&"
import script from "./CompanySpace.vue?vue&type=script&lang=js&"
export * from "./CompanySpace.vue?vue&type=script&lang=js&"
import style0 from "./CompanySpace.vue?vue&type=style&index=0&id=0fd6af0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd6af0b",
  null
  
)

export default component.exports